<script setup>
import {Link} from "@inertiajs/vue3";
import CircleCheckSolidSvg from '@svg/new-circle-check-solid.svg'

defineProps({
    course: Object
})
</script>

<template>
    <div class="player-container">
        <div class="not-player bg-[rgba(0,0,0,0.2)] p-4 2xl:p-14">
            <div class="text-white flex flex-col justify-center h-full w-full px-6 md:px-32 lg:px-40 rounded-2xl text-center">
                <div class="text-[rgba(233,232,255,1)] text-xs md:text-base lg:text-base font-medium">This episode is for members only</div>
                <h1 class="text-lg md:text-2xl lg:text-4xl text-[rgba(243,251,255,1)] font-semibold mt-3 md:mt-6">
                    Sign up to access "{{ course.title }}" right now.
                </h1>

                <div class="mt-3 md:mt-10 space-y-4 md:space-y-8">
                    <Link :href="`/pro`" class="bg-[rgba(25,140,255,1)] inline-flex items-center justify-center rounded-full font-semibold text-[rgba(235,248,255,1)] px-20 h-10 lg:h-12 leading-none drop-shadow-[2px_3px_5px_rgba(25,140,255,0.5)] text-sm lg:text-base">
                        Get started
                    </Link>

                    <div class="text-[rgba(169,198,249,1)] text-xs md:text-sm" v-if="!$page.props.auth.user">
                        Already a member? <Link :href="`/auth/signin`" :data="{ from: $page.url }" preserve-scroll class="text-[rgba(71,167,255,1)]">Sign in</Link> to continue
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
